import { getScaledFont } from '@wix/thunderbolt-becky-root'
import { SignatureInputCssCarmiData, SignatureInputDefinition } from '@wix/thunderbolt-components-native'
import { withCompInfo } from '@wix/editor-elements-integrations'

export const css = withCompInfo<SignatureInputCssCarmiData, SignatureInputDefinition>()(
	// @ts-ignore
	['compLayout', 'styleProperties', 'siteFonts', 'isMobileView', 'compProps'],
	// @ts-ignore
	({ compLayout, styleProperties, siteFonts, isMobileView, compProps }) => {
		const compInfo = { compLayout, styleProperties, siteFonts, isMobileView }
		return {
			'--titleFont': getScaledFont(compInfo, 'titleFont', compProps.labelMobileFontSize),
			'--clearButtonFont': getScaledFont(compInfo, 'clearButtonFont', compProps.inputMobileFontSize),
		}
	}
)
